export const OPTIONS_STAFFING_MODEL = [
	'Partners (K-1)',
	'Employees (W-2)',
	'Independent Contractors (1099)',
	'Prefer not to answer',
];

export const OPTIONS_NUM_EM_PHYSICIAN = [
	'<50',
	'51-100',
	'101-250',
	'251-500',
	'501-1000',
	'1001-2000',
	'>2000',
	'Prefer not to answer',
];

export const OPTIONS_PRACTICE_SIZE = [
	'1-5 contracts/sites',
	'6-20 contracts/sites',
	'>20 contracts/sites',
	'Prefer not to answer',
];

export const OPTIONS_GEOGRAPHIC_DIST = [
	'Local: All sites within 1 state',
	'Regional: All sites within 1-3 states',
	'National: All sites in greater than 3 states',
	'Prefer not to answer',
];

export const OPTIONS_CONTRACT_OWNER = [
	'Single physician contract holder',
	'Group partners/owners - equal',
	'Group partners/owners - tiered/unequal',
	'Non-Academic Hospital and/or Healthcare System',
	'Military/Government',
	'Academic Institution and/or Medical School',
	'All physicians are employees of the hospital and/or healthcare system',
	'Other',
	'Prefer not to answer',
];

export const OPTIONS_GOVERNANCE = [
	'Majority physician governance - equal voting of all physicians',
	'Majority physician governance - tiered/unequal voting of physicians',
	'Representative physician governance',
	'Board of Directors elected by physicians',
	'Board of Directors NOT elected by physicians',
	'Follow hospital and/or instutition bylaws for employed physicians',
	'Non-physician governance',
	'Other',
	'Prefer not to answer',
];

export const OPTIONS_FUNDING = [
	'No outside funding',
	'Loan funding (financial instutitions such as banks, credit unions, bonds)',
	'Hospital funding, no private equity or venture capital',
	'Other external funding - no shares from private equity or venture capital',
	'Other external funding - minority shares from private equity or venture capital with profit sharing rights',
	'Other external funding - majority shares from private equity or venture capital with profit sharing rights',
	'Other',
	'Prefer not to answer',
];

export const OPTIONS_BILLING_DISCLOSURE = [
	'Yes, at least quarterly',
	'Yes, less often than quarterly',
	'Yes, upon request',
	'No',
	'Prefer not to answer',
];

export const OPTIONS_APPS = [
	'Yes, NPs and PAs',
	'Yes, NPs only',
	'Yes, PAs only',
	'No',
	'Prefer not to answer',
];

export const OPTIONS_APPS_UNSUPERVISED = [
	'Yes, NPs and PAs',
	'Yes, NPs only',
	'Yes, PAs only',
	'No',
	'Prefer not to answer',
];

export const OPTIONS_ACEP_POLICIES = [
	{
		label:
			'Compensation Arrangements for Emergency Physicians (Revised April 2021)',
		url: 'https://www.acep.org/patient-care/policy-statements/compensation-arrangements-for-emergency-physicians',
	},
	{
		label:
			'Emergency Physician Compensation Transparency (Approved October 2020)',
		url: 'https://www.acep.org/patient-care/policy-statements/emergency-physician-compensation-transparency',
	},
	{
		label: 'Emergency Physician Contractual Relationships (Revised April 2021)',
		url: 'https://www.acep.org/patient-care/policy-statements/emergency-physician-contractual-relationships',
	},
	{
		label:
			'Emergency Physician Rights and Responsibilities (Revised April 2021)',
		url: 'https://www.acep.org/patient-care/policy-statements/emergency-physician-rights-and-responsibilities',
	},
	{
		label:
			'Providers of Unsupervised Emergency Department Care (Reaffirmed January 2019)',
		url: 'https://www.acep.org/patient-care/policy-statements/providers-of-unsupervised-emergency-department-care',
	},
	{
		label:
			'Guidelines Regarding the Role of Physician Assistants and Nurse Practitioners in the Emergency Department (Revised June 2020)',
		url: 'https://www.acep.org/patient-care/policy-statements/guidelines-regarding-the-role-of-physician-assistants-and-nurse-practitioners-in-the-emergency-department',
	},
	{
		label: 'Corporate Practice of Medicine (Approved June 2023)',
		url: 'https://www.acep.org/patient-care/policy-statements/corporate-practice-of-medicine',
	},
	{
		label: 'Adherence to None',
	},
	{
		label: 'Prefer not to answer',
	},
];
